'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCampaign = exports.fetchCampaignGroups = exports.fetchCampaign = exports.fetchCampaigns = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCampaigns)(params) : (0, _everydayhero.fetchCampaigns)(params);
};

var fetchCampaign = exports.fetchCampaign = function fetchCampaign() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCampaign)(id) : (0, _everydayhero.fetchCampaign)(id);
};

var fetchCampaignGroups = exports.fetchCampaignGroups = function fetchCampaignGroups() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchCampaignGroups)(id) : (0, _everydayhero.fetchCampaignGroups)(id);
};

var deserializeCampaign = exports.deserializeCampaign = function deserializeCampaign(campaign) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeCampaign)(campaign) : (0, _everydayhero.deserializeCampaign)(campaign);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/campaigns/index.js
// module id = 76
// module chunks = 0